import { useEffect, useState } from "react";
import { api } from "../lib/api";

const Chip = ({ on, children, id }) => (
  <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${on ? "bg-emerald-100 text-emerald-800" : "bg-muted text-muted-foreground line-through"}`} data-testid={id}>{children}</span>
);

export const Placement = ({ id, status }) => {
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/admin/articles/${id}/placement`).then((r) => { setP(r.data); setErr(false); }).catch(() => setErr(true)); }, [id, status]);
  if (err) return <p className="mb-4 text-xs text-red-700" data-testid="article-placement-error">Prikaz na naslovnici trenutno nije moguće provjeriti.</p>;
  if (!p) return null;
  const fmt = (s) => (s ? new Date(s).toLocaleString("de-DE", { timeZone: "Europe/Berlin", dateStyle: "medium", timeStyle: "short" }) : "—");
  return (
    <div className="mb-4 rounded-sm border border-border p-3 text-sm" data-testid="article-placement">
      <div className="flex flex-wrap gap-2">
        <Chip on={p.published} id="pl-published">{p.status === "scheduled" ? `Zakazano ${fmt(p.scheduled_at)}` : p.published ? "Objavljeno" : "Nije objavljeno"}</Chip>
        <Chip on={p.is_lead} id="pl-lead">Glavna vijest</Chip>
        <Chip on={p.is_secondary} id="pl-secondary">Sporedne vijesti</Chip>
        <Chip on={!!p.latest_rank} id="pl-latest">Najnovije{p.latest_rank ? ` #${p.latest_rank}` : ""}</Chip>
        {p.is_pinned && <Chip on id="pl-pinned">Zakačeno</Chip>}
      </div>
      {p.published && <p className="mt-2 text-xs text-muted-foreground" data-testid="pl-message">Objavljeno {fmt(p.published_at)} (Berlin). {p.message}</p>}
    </div>
  );
};
